// extracted by mini-css-extract-plugin
export default {"container":"main-navigation_container__4blbs","profile":"main-navigation_profile__qV12F"};